<template>
     <div class="customer-manage">
        <div class="tab">
          <div class="tab-header">
            <div class="item"
              v-for="(item,index) in tabs"
                 :key="index"
                 :class="{on: status == item.status}"
                 @click="tabItemHandle(item)"
            >
              <span class="text">{{item.text}}</span>
              <span class="count" v-if="item.status == 1 && count != 0">{{count}}</span>
            </div>
          </div>
        </div>
       <tab-content
        :status="status"
        @refresh="refresh"
       ></tab-content>
     </div>
</template>

<script>
  import { queryPageWalletTrans } from '@/api/wallet'
  import tabContent from './tabContent'
    export default {
      name: "index",
      components:{
        tabContent,
      },
      data() {
        return {
          tabs: [
            {
              text: '全部',
              status: 0,
            },
            {
              text: '待审核',
              status: 1,
            },
            {
              text: '待支付',
              status: 2,
            },
            {
              text: '审核拒绝',
              status: 5,
            }
          ],
          status: 0,
          count: 8,
        }
      },
      created(){
        this.getCount();
      },
      methods: {
        tabItemHandle(item) {
          this.status = item.status;
        },
        getCount(){
          queryPageWalletTrans({
            page: 1,
            size: 10,
            status: 1,
          }).then((res) => {
            console.log(res);
            this.count = res.data.totalElements;
          })
        },
        refresh(){
          this.getCount();
        }
      },
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variable";
.customer-manage {
  .tab-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 4.15rem;
    background-color: #ffffff;

    padding-left: 2rem;
    .item {
      margin-right: 20px;
      height: 100%;
      line-height: 4.15rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      &.on {
        color: $themeColor;
        border-bottom: 2px solid $themeColor;
      }
      .text {
        color: #5E5873;
        font-size: 14px;
        font-weight: 500;
      }
      .count {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-left: 10px;
        background-color: rgba($themeColor, .12);
        color: $themeColor;
        font-size: 8px;
      }
    }
  }
}
</style>
